import { render } from "./CDateRange.vue?vue&type=template&id=193b2d30"
import script from "./CDateRange.vue?vue&type=script&lang=js"
export * from "./CDateRange.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__